module.exports = __webpack_public_path__ + "img/audio_thumbnail_theodor.66323ea9.png";